import React, { useState } from "react";
import { Button, Card, Radio, Input, Row, Col } from "antd";
import { Toastify } from "../helper/Constant";
import { foodReviewSubmit, checkFoodReviewStatus } from "../../config/services/employeeServices";
import ResponseFilter from "../../ResponseFilter";
import { useHistory } from "react-router-dom";
import { Loader } from "../svg";

const { TextArea } = Input;

const SubmitReview = (props) => {
    const history = useHistory();
    const [responses, setResponses] = useState({});
    const [loader, setLoader] = useState(false);
    const [hasSubmitted, setHasSubmitted] = useState(null); // null: loading, true: submitted, false: not submitted

    React.useEffect(() => {
        checkFoodReviewStatus().then(res => {
            let { status, resData } = ResponseFilter(res);
            if (status && resData && resData.resData && resData.resData.isSubmitted) {
                setHasSubmitted(true);
            } else {
                setHasSubmitted(false);
            }
        }).catch(err => {
            setHasSubmitted(false);
        });
    }, []);

    const handleOptionChange = (questionName, value) => {
        setResponses((prev) => ({
            ...prev,
            [questionName]: value,
        }));
    };

    const handleTextChange = (questionName, text, min, max) => {
        setResponses((prev) => ({
            ...prev,
            [questionName]: text,
        }));
    };

    const getWordCount = (text) => {
        return text ? text.trim().split(/\s+/).filter(word => word.length > 0).length : 0;
    };

    const requiredQuestionsKeys = [
        "q1", "q2", "q3", "q4", "q5", "q6", "q7", "q8", "q9", "q10", "q11", "q12", "q13", "q14"
    ];

    const isQ15Valid = () => {
        if (!responses.q15) return true; // Optional
        const count = getWordCount(responses.q15);
        return count >= 30 && count <= 50;
    };

    const isFormValid = requiredQuestionsKeys.every(key => !!responses[key]) && isQ15Valid();

    const onFinish = () => {
        if (!isFormValid) {
            if (!isQ15Valid()) {
                Toastify("Additional comments (Q15) must be between 30 and 50 words", "error");
            } else {
                Toastify("Please answer all required questions", "error");
            }
            return;
        }

        setLoader(true);
        foodReviewSubmit(responses).then((res) => {
            let { status } = ResponseFilter(res);
            if (status) {
                Toastify("Review submitted successfully", "success");
                setHasSubmitted(true);
            }
            setLoader(false);
        }).catch(err => {
            setLoader(false);
        });
    };

    const questions = [
        {
            name: "q1",
            label: <span>1. How satisfied are you with the overall quality of food served in the canteen? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Very Satisfied", "Satisfied", "Neutral", "Dissatisfied", "Very Dissatisfied"],
        },
        {
            name: "q2",
            label: <span>2. How would you rate the taste and flavor of the meals provided? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Excellent", "Good", "Average", "Poor", "Very Poor"],
        },
        {
            name: "q3",
            label: <span>3. Is the food usually served fresh and at the right temperature? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Always", "Often", "Sometimes", "Rarely", "Never"],
        },
        {
            name: "q4",
            label: <span>4. Are the portion sizes sufficient for your needs? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Always Sufficient", "Mostly Sufficient", "Sometimes Sufficient", "Rarely Sufficient", "Not Sufficient"],
        },
        {
            name: "q5",
            label: <span>5. Do you feel the food quantity matches the price paid? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"],
        },
        {
            name: "q6",
            label: <span>6. How satisfied are you with the variety of menu options available? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Very Satisfied", "Satisfied", "Neutral", "Dissatisfied", "Very Dissatisfied"],
        },
        {
            name: "q7",
            label: <span>7. Are healthy and balanced meal options adequately available? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Always Available", "Often Available", "Sometimes Available", "Rarely Available", "Not Available"],
        },
        {
            name: "q8",
            label: <span>8. How would you rate the cleanliness of the dining area? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Excellent", "Good", "Average", "Poor", "Very Poor"],
        },
        {
            name: "q9",
            label: <span>9. How would you rate the hygiene practices followed by the canteen staff? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Excellent", "Good", "Average", "Poor", "Very Poor"],
        },
        {
            name: "q10",
            label: <span>10. Is the pricing of food items affordable and reasonable? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Very Affordable", "Affordable", "Reasonable", "Expensive", "Very Expensive"],
        },
        {
            name: "q11",
            label: <span>11. How satisfied are you with service speed and staff behavior during peak hours? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Very Satisfied", "Satisfied", "Neutral", "Dissatisfied", "Very Dissatisfied"],
        },
        {
            name: "q12",
            label: <span>12. What is the one major improvement you would like to see in the canteen? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Better Taste", "More Variety", "Improved Hygiene", "Lower Pricing", "Faster Service", "More Healthy Options", "Better Seating & Cleanliness"],
            hasOther: true
        },
        {
            name: "q13",
            label: <span>13. Overall, how would you rate the canteen services? (Rate from 1 to 5) <span style={{ color: 'red' }}>*</span></span>,
            options: ["1 – Least Satisfactory", "2 – Below Average", "3 – Average", "4 – Good", "5 – Best / Highly Satisfactory"],
        },
        {
            name: "q14",
            label: <span>14. Do you think WE SHOULD CONTINUE WITH THE CURRENT FOOD VENDOR? <span style={{ color: 'red' }}>*</span></span>,
            options: ["Yes", "No"],
        },
    ];

    if (hasSubmitted === null) {
        return (
            <div className="body_container cm_bold">
                <Card className="cm_card_shadow">
                    <Loader />
                </Card>
            </div>
        );
    }

    if (hasSubmitted) {
        return (
            <div className="body_container cm_bold">
                <h3 className="mb-4">MONTHLY CANTEEN REVIEW</h3>
                <Card className="cm_card_shadow" style={{ textAlign: "center", padding: "50px" }}>
                    <h2 style={{ color: "#28a745", marginBottom: "20px" }}>Thank You!</h2>
                    <p style={{ fontSize: "18px" }}>You have already submitted your review for this month.</p>
                    <p style={{ fontSize: "16px", color: "#888" }}>Please come back next month for your next review.</p>
                </Card>
            </div>
        );
    }

    return (
        <div className="body_container cm_bold">
            <h3 className="mb-4">MONTHLY CANTEEN REVIEW</h3>
            <Card className="cm_card_shadow">
                <Row gutter={24}>
                    <Col md={12} xs={24}>
                        {questions.slice(0, 7).map((q) => (
                            <div key={q.name} style={{ marginBottom: '20px' }}>
                                <p style={{ fontWeight: '500', marginBottom: '8px' }}>{q.label}</p>
                                <Radio.Group
                                    onChange={(e) => handleOptionChange(q.name, e.target.value)}
                                    value={responses[q.name]}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        {q.options.map((opt) => (
                                            <Radio key={opt} value={opt} style={{ marginBottom: '4px' }}>
                                                {opt}
                                            </Radio>
                                        ))}
                                    </div>
                                </Radio.Group>
                            </div>
                        ))}
                    </Col>
                    <Col md={12} xs={24}>
                        {questions.slice(7, 12).map((q) => (
                            <div key={q.name} style={{ marginBottom: '20px' }}>
                                <p style={{ fontWeight: '500', marginBottom: '8px' }}>{q.label}</p>
                                <Radio.Group
                                    onChange={(e) => handleOptionChange(q.name, e.target.value)}
                                    value={q.hasOther && !q.options.includes(responses[q.name]) && responses[q.name] ? "Other" : responses[q.name]}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        {q.options.map((opt) => (
                                            <Radio key={opt} value={opt} style={{ marginBottom: '4px' }}>
                                                {opt}
                                            </Radio>
                                        ))}
                                        {q.hasOther && (
                                            <Radio value="Other" style={{ marginBottom: '4px' }}>
                                                Other: <Input
                                                    style={{ width: 200, marginLeft: 10 }}
                                                    disabled={responses[q.name] && q.options.includes(responses[q.name])}
                                                    value={q.hasOther && !q.options.includes(responses[q.name]) ? responses[q.name] : ""}
                                                    onChange={(e) => handleOptionChange(q.name, e.target.value)}
                                                />
                                            </Radio>
                                        )}
                                    </div>
                                </Radio.Group>
                            </div>
                        ))}
                        {questions.slice(12).map((q) => (
                            <div key={q.name} style={{ marginBottom: '20px' }}>
                                <p style={{ fontWeight: '500', marginBottom: '8px' }}>{q.label}</p>
                                <Radio.Group
                                    onChange={(e) => handleOptionChange(q.name, e.target.value)}
                                    value={responses[q.name]}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        {q.options.map((opt) => (
                                            <Radio key={opt} value={opt} style={{ marginBottom: '4px' }}>
                                                {opt}
                                            </Radio>
                                        ))}
                                    </div>
                                </Radio.Group>
                            </div>
                        ))}
                    </Col>
                </Row>

                <div style={{ marginBottom: '20px' }}>
                    <p style={{ fontWeight: '500', marginBottom: '8px' }}>
                        15. Additional Comments (Optional, 30-50 words)
                    </p>
                    <TextArea
                        rows={4}
                        placeholder="Share your additional thoughts here..."
                        value={responses.q15}
                        onChange={(e) => handleTextChange("q15", e.target.value)}
                    />
                    <p style={{ fontSize: '12px', color: getWordCount(responses.q15) < 30 || getWordCount(responses.q15) > 50 ? 'red' : '#888', textAlign: 'right' }}>
                        {getWordCount(responses.q15)}/30-50 words
                    </p>
                </div>

                <Button
                    type="primary"
                    onClick={onFinish}
                    className="btn btn-primary"
                    loading={loader}
                    disabled={!isFormValid}
                    style={{ width: '150px', color: "white", marginBottom: '20px', borderRadius: '5px' }}
                >
                    SUBMIT REVIEW
                </Button>
            </Card>
        </div>
    );
};

export default SubmitReview;
